module.exports = __webpack_public_path__ + "assets/images/USDNEW2.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDNEW2.png
// module id = 1461
// module chunks = 1